const access = 'AKIAJXIFY2BEDPAGCXMQ'
const secret = '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'

const creds = new AWS.Credentials({
	accessKeyId: access,
	secretAccessKey: secret
})

let voteList = new Set()

let now = new Date()
let currentTime = now.getHours()

const Lambda = new AWS.Lambda({region: 'eu-west-2', apiVersion: '2015-03-31', credentials: creds})


import { convertToHourlyData, popData, popAdminData, bindListener, bindToggleListener } from './utils.js'
import { popGallery } from './slide-show.js'

export function addImage(data, isInstagram = null) {
	
	let approved, url, owner

	if(isInstagram) {
		approved = data.approved
		url = data.url
		owner = data.owner
	} else {
		approved = data.get('approved') === 'on' ? true : false
		url = data.get('url')
		owner = data.get('owner')
	}

	Lambda.invoke({
		FunctionName : 'VisualDietAdd',
		InvocationType : 'RequestResponse',
		LogType : 'Tail',
		Payload: JSON.stringify({
			url: url,
			approved: approved,
			owner: owner,
			ownerLink: data.ownerLink
		})
	}, (err, data) => {
		if (err) {
			console.log(err, data)
		}
		const response = JSON.parse(data.Payload)

		if(!isInstagram && response.includes('success')) {
			getData('admin')
		}
	})
}

export function voteImage(id, direction) {
	Lambda.invoke({
		FunctionName : 'VisualDietVote',
		InvocationType : 'RequestResponse',
		LogType : 'Tail',
		Payload: JSON.stringify({
			pID: id,
			vote: direction
		})
	}, (err, data) => {
		if (err) {
			console.log(err, data)
		}
		const response = JSON.parse(data.Payload)
	})
}


export function getData(mode = null) {
	Lambda.invoke({
		FunctionName : 'VisualDietEntries',
		InvocationType : 'RequestResponse',
		LogType : 'Tail',
		Payload: JSON.stringify({
			'mode': mode
		})
	}, (err, data) => {
		if (err) {
			console.log(err, data)
		}

		const response = JSON.parse(data.Payload)
		if(mode === 'admin') {
			popAdminData(response)
		} else {
			popGallery(response)
		}

		return response
	})
}

export function approveImage(id, approved) {
	Lambda.invoke({
		FunctionName : 'VisualDiextApproveEntry',
		InvocationType : 'RequestResponse',
		LogType : 'Tail',
		Payload: JSON.stringify({
			pID: id,
			approved: approved
		})
	}, (err, data) => {
		if (err) {
			console.log(err, data)
		}
		const response = JSON.parse(data.Payload)
		getData('admin')
	})
}



// WEBPACK FOOTER //
// ./js/data.js